export async function assets(assets)
{
	if (assets.css)
	{
		BX.loadCSS(assets.css);
	}

	if (assets.js)
	{
		await Promise.all(
			assets.js.map(src => new Promise((resolve, reject) => {
				BX.loadScript(src, resolve)
			}))
		);
	}

	if (assets.string)
	{
		await content(assets.string.toString())
	}

	return true;
}

export async function content(content)
{
	const assets = BX.processHTML(content);
	BX.loadCSS(assets.STYLE);
	if (assets.SCRIPT)
	{
		await new Promise(resolve => {
			BX.ajax.processScripts(assets.SCRIPT, false, resolve)
		});
	}
	return true;
}
